import type { HTMLAttributes } from 'react';
import { GripVertical } from 'lucide-react';
import { cn } from '@/lib/utils';

type SitStatDragHandleProps = {
  ariaLabel: string;
  isDragging?: boolean;
  setActivatorNodeRef?: (element: HTMLElement | null) => void;
  attributes?: HTMLAttributes<HTMLButtonElement>;
  listeners?: HTMLAttributes<HTMLButtonElement>;
};

export function SitStatDragHandle({
  ariaLabel,
  isDragging = false,
  setActivatorNodeRef,
  attributes,
  listeners,
}: SitStatDragHandleProps) {
  return (
    <button
      ref={setActivatorNodeRef}
      type="button"
      className={cn(
        'tw:inline-flex tw:h-7 tw:w-7 tw:shrink-0 tw:cursor-grab tw:items-center tw:justify-center tw:rounded-md tw:text-muted-foreground tw:hover:bg-accent tw:hover:text-foreground',
        isDragging && 'tw:cursor-grabbing'
      )}
      aria-label={ariaLabel}
      {...attributes}
      {...listeners}
    >
      <GripVertical className="tw:h-3.5 tw:w-3.5" />
    </button>
  );
}
